import { FiltersMap } from './filter';
import { ComputedQuery } from './computedQuery';
import { DataResultRaw } from './dataResultRaw';

export type FetchDataFn<T, F extends FiltersMap> = (
  query: ComputedQuery<F>,
) => Promise<DataResultRaw<T>>;
